import { UpperCasePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ProductIconComponent } from '@forgerock/backstage-ui-components';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { SearchResultLinkDirective } from '../../search-result-link.directive';

@Component({
  selector: 'app-search-result-download-meta',
  templateUrl: './search-result-download-meta.component.html',
  styleUrls: [ './search-result-download-meta.component.scss' ],
  imports: [ SearchResultLinkDirective, UpperCasePipe, ProductIconComponent ]
})
export class SearchResultDownloadMetaComponent implements OnInit {
  @Input() result: EverythingSearchResult;
  iconId: string;

  private iconNames = {
    am: 'access-management',
    ds: 'directory-services',
    idm: 'identity-management',
    ig: 'identity-gateway',
    autonomousIdentity: 'autonomous-iam'
  };

  ngOnInit() {
    this.iconId = this.iconNames[ this.result.familyId ] ?? 'platform-icon';
  }

}
